import { render, staticRenderFns } from "./ModelAccessManager.vue?vue&type=template&id=5ce7770d&"
import script from "./ModelAccessManager.vue?vue&type=script&lang=js&"
export * from "./ModelAccessManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports